import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { Suspense, lazy, memo } from 'react';
import { useShallow } from 'zustand/shallow';
import { FillScreen, HStack, VStack } from '@/components/Layout';
import RootHeader from '@/components/Layout/RootHeader';
import { FullScreenOverlay, ViewportLoader } from '@/components/Loading';
import Sidebar from '@/components/Sidebar';
import { useAuthStore } from '@/lib/auth';
import { cn } from '@/lib/cn';
import { featureFlags } from '@/lib/env';
import { useGlobalLoadingStore } from '@/lib/store/loading';
export const Route = createFileRoute('/_stacktrace')({
  // STACKTRACE（PVM）画面へのアクセス可否は ENABLE_STACKTRACE_INCLUDE フラグで制御。
  // prd は flag=false のため、直接 URL アクセスも既定ランディングへ redirect する。
  beforeLoad: () => {
    if (!featureFlags.check('ENABLE_STACKTRACE_INCLUDE')) {
      throw redirect({
        to: '/'
      });
    }
  },
  component: StacktraceLayout
});

/** @see https://tanstack.com/router/latest/docs/framework/react/devtools */
const TanStackRouterDevtools = import.meta.env.PROD ? () => null : lazy(() => import('@tanstack/router-devtools').then(res => ({
  default: res.TanStackRouterDevtools
})));
function StacktraceLayout() {
  const {
    isLoading,
    message
  } = useGlobalLoadingStore();
  return <>
      {isLoading && <FullScreenOverlay message={message} />}
      <StacktraceLayoutWithSidebar />
    </>;
}
const StacktraceLayoutWithSidebar = memo(function StacktraceLayoutWithSidebar() {
  const refreshUserSession = useAuthStore(useShallow(({
    refreshUserSession
  }) => refreshUserSession));
  return <FillScreen className="bg-neutral-bottom-fill">
        <VStack className="h-full">
          <RootHeader />
          <HStack className="flex-1 overflow-hidden">
            <Sidebar refreshUserSession={refreshUserSession} />
            <main className={cn('flex-1 overflow-auto')}>
              <div className="h-full">
                <Suspense fallback={<ViewportLoader />}>
                  <Outlet />
                </Suspense>
              </div>
            </main>
            <Suspense>
              <TanStackRouterDevtools />
            </Suspense>
          </HStack>
        </VStack>
      </FillScreen>;
});